import { render, staticRenderFns } from "./payment-sync-modal.vue?vue&type=template&id=36d69ef2&scoped=true&"
import script from "./payment-sync-modal.vue?vue&type=script&lang=ts&"
export * from "./payment-sync-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d69ef2",
  null
  
)

export default component.exports